import { defineComponent as _defineComponent } from 'vue'
import { IRoadEvent } from "@/domain/entities/roadEvent";
import { computed, PropType } from "vue";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";


const __default__ = {
  name: "RoadEventRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  roadEvent: {
    type: Object as PropType<IRoadEvent>,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

dayjs.extend(isBetween);

const props = __props;

const incidentGradeLookupTable: Record<string, string> = {
  A등급: "grade-a",
  B등급: "grade-b",
  C등급: "grade-c",
};

const displayDates = computed(() => {
  const { beginDtm, endDtm } = props.roadEvent;
  const fromDate = dayjs(beginDtm).format("YYYY.MM.DD HH:mm");

  if (endDtm) {
    const endDate = dayjs(endDtm).format("YYYY.MM.DD HH:mm");
    return `${fromDate} ~ ${endDate}`;
  } else {
    return `${fromDate} ~`;
  }
});

const isPastRoadEvent = computed(() => {
  const { beginDtm, endDtm } = props.roadEvent;
  const isFutureRoadEvent = dayjs().isBefore(beginDtm, "minute");
  if (isFutureRoadEvent) {
    return false;
  }

  return endDtm ? dayjs().isAfter(endDtm, "minute") : false;
});

const __returned__ = { props, incidentGradeLookupTable, displayDates, isPastRoadEvent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})